const infraErrorPattern =
  /\b(auth0|bucket|constraint|database|db|endpoint|er_[a-z0-9_]+|mysql|s3|sql|typeorm)\b/i

/**
 * Sentences written for the person to read, verbatim. Everything the auth
 * modules deliberately say is on this list; anything else that leaks up is an
 * internal error and collapses to the caller's fallback. The refusal sentence
 * matters most: without it here, a denied sign-in reached the login page as
 * "Could not sign in." -- true, useless, and indistinguishable from an outage.
 */
const deliberateMessages = new Set([
  "Ask an administrator to set up your account.",
  "That sign-in link has expired. Try again.",
  "That code has expired. Request a new one.",
  "That code is not valid.",
  "Google sign-in is not available.",
  "Sign-in is not available.",
])

export function dashboardApiErrorMessage(error: unknown, fallback: string) {
  const message = error instanceof Error ? error.message.trim() : ""
  if (!message) return fallback
  if (deliberateMessages.has(message)) return message
  if (infraErrorPattern.test(message)) return fallback
  return /^Could not [a-z][\w\s-]+\.$/.test(message) ? message : fallback
}
